import color from './color';

const misc = {
  border: `1px solid ${color.border}`,
  borderRadius: '0.5rem',
};

export default misc;

